import { Component, Injector, Input, OnInit } from '@angular/core';
import _, { toUpper } from 'lodash';
import { ListingBaseComponent } from 'src/app/shared/components/base/listing-base.component';
import { VERIFICATION } from 'src/app/shared/constants/constant-list';
import { VerificationType } from 'src/app/shared/interfaces/Compliance';
import { Features } from 'src/app/shared/interfaces/Features';
import { IUser } from 'src/app/shared/interfaces/User';

@Component({
  selector: 'app-generic-partner-user-profile',
  templateUrl: './generic-partner-user-profile.component.html',
  styleUrls: ['./generic-partner-user-profile.component.scss'],
})
export class GenericPartnerUserProfileComponent
  extends ListingBaseComponent
  implements OnInit
{
  @Input() details?: Partial<IUser>;

  public user: any;

  VERIFICATION?: string;
  features?: any[] = [];
  cashOutFeature: Features | null = null;
  allFeatures: Features | null = null;
  verificationStatus: VerificationType | null = null;

  WALLET_TYPE_ID?: any;

  constructor(injector: Injector) {
    super(injector);

    this.user = this.userService.user;
    const CONFIG_ = this.user?.partner?.config?.cms?.sections;
    const TRANSACTIONS = CONFIG_?.transactions?.table;

    this.WALLET_TYPE_ID = TRANSACTIONS.source?.initial_filters?.wallet_type_id;
  }

  ngOnInit(): void {
    this.route.data.subscribe((data) => {
      if (data && data.data) {
        this.details = data.data;
        this.features = this.details?.features;

        this.VERIFICATION = this.details?.compliance?.verification_status;

        this.generateFeatures(this.features);
      }
    });
  }

  private generateFeatures = (_features: any) => {
    this.cashOutFeature = _.find(this.details?.features, {
      feature: 'cash-out',
    })!;
    this.allFeatures = _.find(this.details?.features, {
      feature: 'all',
    })!;
  };

  getUserEKYCStatus(): string {
    return toUpper(this.verificationStatus!);
  }

  getUserEKYCStatusClass(): string {
    if (this.verificationStatus === VERIFICATION.verified) {
      return 'fully-verified';
    } else if (
      this.verificationStatus === VERIFICATION.pending ||
      this.verificationStatus === VERIFICATION.soft_deleted
    ) {
      return 'soft-deleted';
    } else if (this.verificationStatus === VERIFICATION.failed) {
      return 'jumio';
    } else if (this.verificationStatus === VERIFICATION.in_progress) {
      return 'unverified';
    }
    return '';
  }
}
